const routers = [
    {
        path: '/newindex',
        name: 'newindex',
        meta: {
          exp: '新首页',
          requireAuth: false
        },
        redirect: '/newhome',
        component: () => import('@/views/GJH/index.vue'),
        children: [
          {
            path: '/newhome',
            name: 'newhome',
            meta: {
              exp: '新首页',
              requireAuth: false
            },
            component: () => import('@/views/GJH/home/index.vue'),
          },
          {
            path: '/zxzt',
            name: 'zxzt',
            meta: {
              exp: '专项展厅',
              requireAuth: false
            },
            component: () => import('@/views/GJH/zxzt/index.vue'),
          },
          {
            path: '/zxzt_detail',
            name: 'zxzt_detail',
            meta: {
              exp: '专项展厅详情',
              requireAuth: false
            },
            component: () => import('@/views/GJH/zxzt/detail/index.vue'),
          },
          {
            path: '/zhzt',
            name: 'zhzt',
            meta: {
              exp: '综合展厅',
              requireAuth: false
            },
            component: () => import('@/views/GJH/zhzt/index.vue'),
          },
        ]
      },
]
export default routers